import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSortBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={2.596} y={7.345} width={12} height={1} rx={0.5} fill="#4D4D4D" />
    <rect x={2.596} y={11.345} width={8} height={1} rx={0.5} fill="#4D4D4D" />
    <rect x={2.596} y={15.345} width={4} height={1} rx={0.5} fill="#4D4D4D" />
  </svg>
);
const Memo = memo(SvgSortBox);
export default Memo;
